import styled, { css } from 'styled-components/macro';
import { ArtworkWrapper } from 'components/base/Artwork/Artwork.style';
import { DefaultMetaData } from 'components/Header/EntityMetadata/EntityMetadata';
import { ReactComponent as Caret } from 'icons/icon-toggle-caret.svg';
import Anchor from 'components/base/Anchor/Anchor';
import colors from 'styles/themes/colors';

export const BreadcrumbWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  color: ${colors.White};
  flex-wrap: wrap;
  border-top: 1px solid rgba(255, 255, 255, 0.2);

  flex-direction: ${({ isMobile }): string => (isMobile ? 'column' : 'row')};
  align-items: ${({ isMobile }): string => (isMobile ? 'left' : 'center')};

  padding: ${({ isMobile }): string => (isMobile ? '10px 0' : '0')};

  a {
    box-shadow: 0px 1px 0px 0px ${colors.White};
    white-space: nowrap;

    &:hover {
      box-shadow: 0px 2px 0px 0px ${colors.White};
    }
  }

  ${DefaultMetaData} {
    margin-bottom: 0;
    margin-left: ${({ theme }): string => theme.spacing.xxsmall};

    span:before {
      content: ' • ';
      margin: 0 ${({ theme }): string => theme.spacing.xxsmall};
    }
  }

  ${ArtworkWrapper} {
    width: 35px;
    height: 35px;
    margin-right: ${({ theme }): string => theme.spacing.xsmall};
    svg {
      width: 35px;
      height: 35px;
    }
  }
`;

export const ArtistElement = styled.div<{ isMobile: boolean }>`
  display: flex;
  padding: ${({ theme }): string => `0 ${theme.spacing.large}`};
  margin: 15px 0;
  align-items: center;

  &:not(:first-of-type) {
    border-left: 1px solid rgba(255, 255, 255, 0.28);
  }

  ${({ isMobile }): any =>
    isMobile &&
    css`
      border-left: none !important;
      margin: 2px 0;
      padding-left: ${({ theme }): string => `${theme.spacing.medium}`};
    `};
`;

export const CaretIcon = styled(Caret)`
  transform: rotate(90deg);
  color: ${colors.White};
  margin-right: 15px;
`;

export const MobileAnchor = styled(Anchor)`
  box-shadow: none !important;
  display: flex;
  align-items: center;

  > span {
    box-shadow: 0px 1px 0px 0px ${colors.White} !important;
  }
`;
